<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.motivoBaixa"
        ref="DataTable"
        sort-by="descricao"
        search-by="descricao"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'almoxarifado-motivo-baixa-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-almoxarifado-motivo-baixa"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-almoxarifado-motivo-baixa"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            motivoBaixa: this.getConectaSusRepository('almoxarifado.motivoBaixa')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'almoxarifadoMotivoBaixaTipo.nome',
                    key: 'tipo',
                    label: 'Tipo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'almoxarifadoMotivoBaixa.descricao',
                    key: 'descricao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'almoxarifadoMotivoBaixa.justificar',
                    key: 'justificar',
                    label: 'Justificar',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.motivoBaixa.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o motivo de baixa?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>